module.exports = __webpack_public_path__ + "static/img/cgqd(1).00e87de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cgqd(1).png
// module id = 0kaX
// module chunks = 1